export const PORTAL_LOCALES = ['zh', 'en', 'vi'] as const
export const DEFAULT_PORTAL_LOCALE = 'zh'

export type PortalLocale = (typeof PORTAL_LOCALES)[number]

export const isPortalLocale = (locale: string | null | undefined): locale is PortalLocale =>
  PORTAL_LOCALES.some((candidate) => candidate === locale)

export const resolvePortalLocale = (
  preferredLocale: string | null | undefined,
  legacyLocale?: string | null
): PortalLocale => {
  if (isPortalLocale(preferredLocale)) return preferredLocale
  if (isPortalLocale(legacyLocale)) return legacyLocale
  return DEFAULT_PORTAL_LOCALE
}

export const readPortalLocale = (): PortalLocale =>
  resolvePortalLocale(localStorage.getItem('preferred-language'), localStorage.getItem('locale'))

export const writePortalLocale = (locale: PortalLocale): void => {
  localStorage.setItem('preferred-language', locale)
  localStorage.setItem('locale', locale)
}
